// Copyright 2019 Bik_krl
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

export const CREATE_PRODUCT_BRAND = "CREATE_PRODUCT_BRAND";
export const GET_ALL_PRODUCT_BRAND = "GET_ALL_PRODUCT_BRAND";
export const UPDATE_PRODUCT_BRAND = "UPDATE_PRODUCT_BRAND";
export const REMOVE_PRODUCT_BRAND = "REMOVE_PRODUCT_BRAND";
export const PRODUCT_BRAND_MODAL = "ProductBrandModal";
export const PRODUCT_BRAND_LOADING = "PRODUCT_BRAND_LOADING";
